import update from 'immutability-helper'
import _ from 'lodash'
import {
  getCustomMaster,
  getCustomOrderList,
  delCustomOrderById,
  getCustomSum,
  exportCustomOrder,
} from "utils/interface";
import { CQ } from "utils/commonQuest";
import { message } from 'antd';

const initCustomOrderListState = {
  masterList: [],
  queryResult: {
    total: 0,
    list: []
  },
  page: {
    current: 1,
    pageSize: 10,
  },
  queryParams: {

  },
  statistics:{
    cost:0,
    amout:0,
    profit:0
  }
}

//  数据模型
// import Model from "../viewModel";
export const customOrderList = {
  name: "customOrderList",
  state: initCustomOrderListState,
  reducers: {
    setFieldValue(state, data: any) {
      const { field, value } = data
      let newData = {
        [field]: { $set: value } 
      };
      return update(state, newData)
    },
    resetQueryParams(state) {
      return update(state, {
        queryParams: { $set: initCustomOrderListState.queryParams }
      })
    }
  },
  effects: {
    async getCustomMasterList(payload: any, rootState: any) {
      // 允许接口完成调用后，执行组件中的方法
      const param = { ...payload };
      // 删除参数对象中的callback对象，以便不传多余的参数
      delete param.callback;
      // 等待异步调用的结果
      const data = await CQ(getCustomMaster(param));
      this.setFieldValue({
        field: 'masterList',
        value: data,
      })
    },
    async customOrderListSearchFormQuery(payload: any, rootState:any){
      let { customOrderList } = rootState;
      let { queryParams, page } = customOrderList;
      const param = { ...queryParams, page: page.current,rows: page.pageSize, ...payload}
      const data = await CQ(getCustomOrderList(param));
      const statistics = await CQ(getCustomSum(param));
      this.setFieldValue({
        field: 'queryResult',
        value: data,
      })
      this.setFieldValue({
        field: 'queryParams',
        value: param
      })
      this.setFieldValue({
        field: 'statistics',
        value: statistics
      })
    },
    async onShowSizeChange(payload: any, rootState:any){
      await this.customOrderListSearchFormQuery({
          rows: payload.size,
          page: payload.current,
      })
      this.setFieldValue({
        field: 'page',
        value: {
          pageSize: payload.size,
          current: payload.current,
        },
      })
    },
    async onChange(payload: any, rootState:any){
      await this.customOrderListSearchFormQuery({
          rows: payload.pageSize,
          page: payload.page,
      })
      this.setFieldValue({
        field: 'page',
        value: {
          pageSize: payload.pageSize,
          current: payload.page,
        },
      })
    },
    async delRow(payload:any, rootState:any){
      if(payload && payload.id){
        await CQ(delCustomOrderById({
          id: payload.id
        }));
        await this.customOrderListSearchFormQuery();
        message.success('删除成功!')
      }
    },
    async exportCustomOrderList(payload:any, rootState:any){
      const result = await CQ(exportCustomOrder(payload), true);
      return result;
    },
    async resetQueryParamsAndQuery(payload:any, rootState:any){
      let { customOrderList } = rootState;
      let { page } = customOrderList;
      const param = {page: page.current,rows: page.pageSize, ...payload}
      const data = await CQ(getCustomOrderList(param));
      const statistics = await CQ(getCustomSum(param));
      this.setFieldValue({
        field: 'queryResult',
        value: data,
      })
      this.setFieldValue({
        field: 'queryParams',
        value: param
      })
      this.setFieldValue({
        field: 'statistics',
        value: statistics
      })
    }
  }
};
